import { Quaternion as n, Object3D as o } from "three";
import { getQuaternion as e } from "./index13.js";
const i = new n(), c = (t, r = new o()) => (r.position.fromArray(t.pos), r.quaternion.copy(e(t, i)), r);
export {
  c as getObject3D
};
//# sourceMappingURL=index10.js.map
